import React, { useState } from 'react';
import CollectionPointMap from '../Components/CollectionPoints/CollectionPointMap';
import CollectionPointList from '../Components/CollectionPoints/CollectionPointList';
import AddCollectionPoint from '../Components/CollectionPoints/AddCollectionPoint';

function CollectionPointsPage() {
  const [activeTab, setActiveTab] = useState('map');
  const [showAddForm, setShowAddForm] = useState(false);
  const isAdmin = localStorage.getItem('role') === 'admin';

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-br from-[#003d32] to-[#006b57] text-white py-14 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
              <i className="fas fa-map-marker-alt text-white text-lg"></i>
            </div>
            <span className="text-green-300 text-sm font-medium uppercase tracking-widest">Recycling Network</span>
          </div>
          <h1 className="text-4xl font-bold mb-3">Collection Points</h1>
          <p className="text-green-200 text-lg max-w-2xl">
            Find your nearest e-waste collection centre across London, Greenwich and Essex. Drop off your old electronics and earn reward points for every recycling submission.
          </p>
          <div className="flex flex-wrap gap-6 mt-8">
            <div className="flex items-center gap-2 text-sm text-green-200">
              <i className="fas fa-check-circle text-green-400"></i>
              Free drop-off service
            </div>
            <div className="flex items-center gap-2 text-sm text-green-200">
              <i className="fas fa-check-circle text-green-400"></i>
              Earn reward points
            </div>
            <div className="flex items-center gap-2 text-sm text-green-200">
              <i className="fas fa-check-circle text-green-400"></i>
              Environmentally certified
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-1 inline-flex mb-8">
          <button
            onClick={() => setActiveTab('map')}
            className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
              activeTab === 'map'
                ? 'bg-[#004d3f] text-white shadow-sm'
                : 'text-gray-600 hover:text-[#004d3f]'
            }`}
          >
            <i className="fas fa-map"></i>
            Map View
          </button>
          <button
            onClick={() => setActiveTab('list')}
            className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
              activeTab === 'list'
                ? 'bg-[#004d3f] text-white shadow-sm'
                : 'text-gray-600 hover:text-[#004d3f]'
            }`}
          >
            <i className="fas fa-list"></i>
            List View
          </button>
        </div>

        {activeTab === 'map' && (
          <div className="mb-10">
            <CollectionPointMap />
          </div>
        )}

        {activeTab === 'list' && (
          <div className="mb-10">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-xl font-bold text-gray-800">Collection Points near Greenwich & Essex</h2>
                <p className="text-gray-500 text-sm mt-1">Sorted by proximity to University of Greenwich</p>
              </div>
            </div>
            <CollectionPointList />
          </div>
        )}

        {isAdmin && (
          <div className="mb-10">
            <button
              onClick={() => setShowAddForm(!showAddForm)}
              className="flex items-center gap-2 bg-[#004d3f] text-white px-6 py-3 rounded-xl font-medium hover:bg-[#003d32] transition-colors shadow-sm"
            >
              <i className={`fas fa-${showAddForm ? 'times' : 'plus'}`}></i>
              {showAddForm ? 'Cancel' : 'Add New Collection Point'}
            </button>
            {showAddForm && (
              <div className="mt-6">
                <AddCollectionPoint onSuccess={() => setShowAddForm(false)} />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default CollectionPointsPage;
